import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class JobsService {

  http: HttpClient = inject(HttpClient);
  constructor() { }

  async getAllJobs() {
    return new Promise(resolve => {
      this.http.get(`${environment.apiUrl}/job`)
        .subscribe({
          next: data => resolve(data),
          error: err => console.log(err)
        })
    })
  }

  async getJob(id: string) {
    return new Promise(resolve => {
      this.http.get(`${environment.apiUrl}/job/${id}`)
        .subscribe({
          next: data => resolve(data),
          error: err => console.log(err)
        })
    })
  }
}
